import {VettableCreator} from '@/types/vettableCreatorsResponse';

const getAvatarSrc = (creator: VettableCreator) =>
  typeof creator.profileImage === 'string'
    ? creator.profileImage
    : (creator.profileImage?.thumbJpg ?? creator.profileImage?.platforms?.[0]);

export default getAvatarSrc;
